<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col class="lg-12">
        <material-card
          class="card-tabs"
          color="success"
        >
          <v-col
            slot="header"
          >
            <v-tabs
              v-model="active"
              background-color="transparent"
              slider-color="white"
              grow
            >
              <v-tab                
                v-for="system in tabs"
                :key="system.key"
              >
                {{ system.name }}
              </v-tab>
            </v-tabs>
          </v-col>

          <v-tabs-items 
            v-model="active"
          >
            <v-tab-item
              v-for="(tab, i) in tabs"
              :key="tab.key"
              :transition="false" 
              :reverse-transition="false"
              eager
            >
              <v-fade-transition>
                <setup-roles-container-view
                  v-show="active === i" 
                  :ref="tab.key"
                  :type="tab.key"
                />
              </v-fade-transition>
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupRolesContainerView: () => import('@/components/setup/roles/ContainerView'),
    },
    metaInfo () {
      return {
        title: 'Setup - Roles',
      }
    },
    data () {
      return {
        tabs: [
          {
            name: 'Workspace Roles',
            key: 'hrm',
          },
          // {
          //   name: 'CRM Roles',
          //   key: 'crm',
          // },
          // {
          //   name: 'AMS Roles',
          //   key: 'ams',
          // },
          // {
          //   name: 'CMS Roles',
          //   key: 'cms',
          // },
          // {
          //   name: 'MASTER ROLES',
          //   key: 'master',
          // },
          {
            name: 'LMSPro Roles',
            key: 'lmspro',
          },
          // {
          //   name: 'AP ROLES',
          //   key: 'ap',
          // },
        ],
        active: null,
      }
    },
    ready: function () {
      this.loadHrmRoles()
    },

    watch: {
      active: {
        handler (value) {
          // if (value === 0) {
          //   this.loadHrmRoles()
          // } else if (value === 1) {
          //   this.loadCrmRoles()
          // } else if (value === 2) {
          //   this.loadAmsRoles()
          // } else if (value === 3) {
          //   this.loadCmsRoles()
          // } else if (value === 4) {
          //   this.loadMasterRoles()
          // } else if (value === 5) {
          //   this.loadLmsProRoles()
          // } else {
          //   this.loadApRoles()
          // }
          if (value === 0) {
            this.loadHrmRoles()
          } else if (value === 1) {
            this.loadLmsProRoles()
          } 
        },
      },
    },
    methods: {
      loadHrmRoles () {   
        if (this.$refs.hrm[0].noOfRoles > 0) return

        this.$refs.hrm[0].getRoleList()
      },
      // loadCrmRoles () {
      //   if (this.$refs.crm[0].noOfRoles > 0) return

      //   this.$refs.crm[0].getRoleList()
      // },
      // loadAmsRoles () {
      //   if (this.$refs.ams[0].noOfRoles > 0) return

      //   this.$refs.ams[0].getRoleList()
      // },
      // loadCmsRoles () {
      //   if (this.$refs.cms[0].noOfRoles > 0) return

      //   this.$refs.cms[0].getRoleList()
      // },
      loadMasterRoles () {
        if (this.$refs.master[0].noOfRoles > 0) return
        
        this.$refs.master[0].getRoleList()
      },
      loadLmsProRoles () {
        if (this.$refs.lmspro[0].noOfRoles > 0) return
        
        this.$refs.lmspro[0].getRoleList()
      },
      // loadApRoles () {
      //   if (this.$refs.ap[0].noOfRoles > 0) return
        
      //   this.$refs.ap[0].getRoleList()
      // },
    },
  }
</script>
